import React, { Component, Fragment } from 'react';
import {connect} from 'react-redux';
import axios from "axios";
import isEmpty from "lodash/isEmpty";

// Components
import Loader from '../../../utils/Loader';
import Select from 'react-select';
import ImportResults from './ImportResults';

// CSS
import '../../../../css/csv-input.css';

import { loadTopTiers } from '../../../../store/actions/topTier';
import { addRoute } from '../../../../store/actions/route';
import { userTokenUpdate, userLogout } from "../../../../store/actions/user";
import { setpageTitle } from '../../../../store/actions/siteInfo';
import { REACT_APP_API_URL, REACT_APP_SITE_KEY, REACT_APP_RESOURCE_URL } from "../../../../shared/vars";

class AdminTopTierImport extends Component{
    constructor(props){
        super(props)
        this.state = {
            topTierSelected: {},
            topTierIndex: null,
            csvData: [],
            fileLoaded: false,
            importing: false,
            resultsLog: [],
            showResults: false,
            error: {},
        }

        this.props.addRoute(this.props.match)
        this.props.setpageTitle('Top Tier Import')
    }

    componentDidMount(){
        this.props.loadTopTiers();
    }

    handleSelectBoxChange = (id) => {
        this.setState({   
            topTierIndex: id,
            topTierSelected: this.props.topTiers[id],
            csvData: [],
            fileLoaded: false,
            resultsLog: [],
            importing: false
        }, 
        () => { this.props.loadTopTiers() });
    }

    fileLoaded = e => {
        const files = e.target.files;
        const reader = new FileReader();
        let data = [];
        if(files[0] instanceof Blob){

            reader.readAsText(files[0]);

            // When file is cancelled
            reader.onabort = () => { this.setState({fileLoaded: false}) }

            // When file is finished loading
            reader.onloadend = (e) => {

                let results = e.target.result.split("\n");
                results.forEach(element => {
                    if(!isEmpty(element))
                        data.push(element.split(","))
                });

                // console.log(data);
                this.setState({
                    fileLoaded: true,
                    csvData: data
                })
            }
        }
    }

    importCustomers(){
        this.setState({
            importing: true
        }, () => {
            const token         = this.props.user.token;
            const AUTH_HEADER   = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };

            let item = { 
                // customers: [{name: 'test', age: 12}, {name: 'test', age: 14}]
                top_tier_id: this.state.topTierSelected.id,
                customers: this.state.csvData 
            }

            return axios.post(REACT_APP_API_URL + "customer-import/", item, { headers: AUTH_HEADER })
                .then(response => {
                    console.log(response);
                    if (response.status === 403 || (response.data.status && response.data.status === 403)) {
                        this.props.userLogout("admin");
                    } else if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {
                        this.setState({ importing: false, error: response.data.message });
                    } else {
                        this.setState({
                            importing: false,
                            resultsLog: response.data.results_log
                        });
                    }
                })
                .catch(err => {
                    if (err.response) {
                        this.setState({ importing: false, error: err.response.data.errors ? err.response.data.errors : err.response.data.message });
                    } else {
                        this.setState({ importing: false, error: err.message });
                    }
                });
        })
    }

    render(){
        const { topTierIndex, fileLoaded, importing, showResults } = this.state;
        const { topTiers, topTiersLoading } = this.props;

        // Select Box Values
        const topTierOptions = [];
        let i = 0;
        !isEmpty(topTiers) && topTiers.forEach(element => {
            topTierOptions.push({value: i++, label: element.name});
        })

        console.log(this.state.resultsLog);

        return (
            <Fragment>
                <h1>Top Tier Customer Import</h1>
                <div className="instruction">Choose a top tier and then import a csv file to add multiple customers to a top tier at once. Press the "Download CSV Template" button to format csv properly. Each entry must require a first name, last name and email. </div>

                {/* Loading */
                topTiersLoading ? 
                <div className="pt2 pb2">
                    <Loader />
                </div> :
                /* Page Content */
                <Fragment>
                    {!!topTiers && topTiers.length <= 0 ? <div>There are currently no top tiers to display.</div> :
                    <Fragment>
                        {/* Top Tier Select Box */}
                        <div className="tt-select-container">
                            <div className="tt-prod-select">
                                <div className="tt-prod-select-label">Select Top Tier:</div>
                                <Select className="select-box" 
                                    name={`top_tier_id`} 
                                    value={topTierIndex} 
                                    onChange={selection => this.handleSelectBoxChange(selection.value)} 
                                    clearable={false} 
                                    valueKey="value"
                                    labelKey="label" 
                                    options={topTierOptions} 
                                />
                            </div>
                            <a href={REACT_APP_RESOURCE_URL + 'csv-downloads/templates/customer_import.csv'} target="_blank" rel="noopener noreferrer"><button className="btn">Download CSV Template</button></a>
                        </div>
                        <hr className="tt-hr-divider"/>

                        {/* Load Component */}
                        {topTierIndex != null && 
                            <div className="csv-input-container">
                                <div className="csv-input">
                                    <h2 className="csv-input-header">UPLOAD CSV FILE</h2>
                                    <div className="react-csv-input" >
                                        <input type="file" name="file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={(e) => this.fileLoaded(e)}/>
                                    </div>
                                </div>
                                {fileLoaded && 
                                <div style={{padding: '0.75em'}}>
                                <button className="btn" onClick={() => this.importCustomers()}>{importing ? <div className="csv-input-loader"></div> : 'Import Customers'}</button>
                                </div>
                                }
                            </div>
                        }
                        {/* Show Results */}
                        {!isEmpty(this.state.resultsLog) &&
                        <Fragment>
                            <button 
                                className="btn results-btn" 
                                onClick={() => this.setState({ showResults: !this.state.showResults })}
                            >
                                {showResults ? 'Hide' : 'Show'} Results ({Object.entries(this.state.resultsLog).length}) <span className={`icon-chevron-${showResults ? 'up' : 'down'}`}></span>
                            </button>
                            
                            {showResults &&
                            <ImportResults 
                                results={!!this.state.resultsLog ? Object.entries(this.state.resultsLog) : []}
                                itemsPerPage={10}
                            />
                            }
                        </Fragment>
                        }
                    </Fragment>
                    }
                </Fragment>
                }
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.admin,
        topTiers: state.topTier.topTiers,
        topTiersLoading: state.topTier.topTiersLoading
    }
}

export default connect(mapStateToProps, {addRoute, setpageTitle, loadTopTiers, userTokenUpdate, userLogout})(AdminTopTierImport)


// WEBPACK FOOTER //
// ./src/components/admin/top-tiers/importer/AdminTopTierImport.js